import { render, staticRenderFns } from "./form-produtor.vue?vue&type=template&id=d1ab64a2&"
import script from "./form-produtor.vue?vue&type=script&lang=js&"
export * from "./form-produtor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports